export default __webpack_public_path__ + "static/media/moonrace_background.fa7455b2.png";